module.exports = __webpack_public_path__ + "img/06.377e033b.jpg";